import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
  CollapsibleStyled,
  OuterContainer,
  InnerContainer,
  TriggerButton,
  TriggerButtonWrap,
  StyledText,
  StyledIcon,
} from './styles/CollapsibleStyled';

const OPEN_STATE = {
  OPEN: 'open',
  OPENING: 'opening',
  CLOSE: 'close',
  CLOSING: 'closing',
};

class Collapsible extends PureComponent {
  constructor(props) {
    super(props);
    const { defaultOpen } = this.props;
    let state;
    if (defaultOpen) {
      state = {
        openState: OPEN_STATE.OPEN,
        height: 'auto',
        transition: 'none',
      };
    } else {
      state = {
        openState: OPEN_STATE.CLOSE,
        height: 20,
      };
    }
    this.state = state;
  }

  UNSAFE_componentWillReceiveProps({ defaultOpen }) {
    const { defaultOpen: prevDefaultOpen } = this.props;
    if (defaultOpen && prevDefaultOpen !== defaultOpen) {
      this.setState({
        openState: OPEN_STATE.OPEN,
        height: 'auto',
        transition: 'none',
      });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { openState } = this.state;
    const { openState: prevOpenState } = prevState;
    if (openState !== prevOpenState && openState === OPEN_STATE.CLOSING) {
      setTimeout(this.continueCloseCollapsible, 50);
    }
  }

  onInnerRef = (ref) => {
    this.inner = ref;
  };

  onOuterRef = (ref) => {
    this.outer = ref;
  };

  handleTriggerClick = (e) => {
    e.preventDefault();
    const { handleTriggerClick, accordionPosition, triggerDisabled } = this.props;
    const { openState } = this.state;

    if (triggerDisabled === true) {
      return;
    }

    if (handleTriggerClick === true) {
      handleTriggerClick(accordionPosition);
    } else if (openState === OPEN_STATE.CLOSE || openState === OPEN_STATE.CLOSING) {
      this.openCollapsible();
    } else if (openState === OPEN_STATE.OPEN || openState === OPEN_STATE.OPENING) {
      this.closeCollapsible();
    }
  };

  closeCollapsible = () => {
    this.setState({
      height: this.inner.offsetHeight,
      openState: OPEN_STATE.CLOSING,
    });
  };

  continueCloseCollapsible = () => {
    const { transitionTime, easing } = this.props;

    this.setState({
      height: 20,
      transition: `height ${transitionTime}ms ${easing}`,
    });
  };

  openCollapsible = () => {
    const { transitionTime, easing } = this.props;

    this.setState({
      height: this.inner.offsetHeight,
      transition: `height ${transitionTime}ms ${easing}`,
      openState: OPEN_STATE.OPENING,
    });
  };

  handleTransitionEnd = (e) => {
    // Switch to height auto to make the container responsive
    if (e.target === this.outer) {
      const { openState } = this.state;
      let newState;
      if (openState === OPEN_STATE.OPENING) {
        newState = {
          height: 'auto',
          openState: OPEN_STATE.OPEN,
        };
        this.props.onOpen();
      } else if (openState === OPEN_STATE.CLOSING) {
        newState = {
          openState: OPEN_STATE.CLOSE,
        };
        this.props.onClose();
      }
      if (newState) {
        this.setState(newState);
      }
    }
  };

  render() {
    const { triggerText, triggerIcon, children, onRef } = this.props;

    const { height, transition, openState } = this.state;

    const dropDownStyle = {
      height,
      WebkitTransition: transition,
      msTransition: transition,
      transition,
    };

    return (
      <CollapsibleStyled ref={onRef}>
        <TriggerButton onClick={this.handleTriggerClick}>
          <TriggerButtonWrap>
            <StyledIcon
              active={openState === OPEN_STATE.OPEN || openState === OPEN_STATE.OPENING}
              name={triggerIcon}
              color="#A6A6A6"
              size={12}
            />
            <StyledText color="gray" font="din_bold" type="uppercase">
              {triggerText}
            </StyledText>
          </TriggerButtonWrap>
        </TriggerButton>
        <OuterContainer
          onTransitionEnd={this.handleTransitionEnd}
          ref={this.onOuterRef}
          style={dropDownStyle}
          data-role="collapsibleContent"
        >
          <InnerContainer ref={this.onInnerRef}>{children}</InnerContainer>
        </OuterContainer>
      </CollapsibleStyled>
    );
  }
}

Collapsible.propTypes = {
  transitionTime: PropTypes.number,
  easing: PropTypes.string,
  defaultOpen: PropTypes.bool,
  accordionPosition: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  handleTriggerClick: PropTypes.func,
  onOpen: PropTypes.func,
  onClose: PropTypes.func,
  triggerText: PropTypes.string,
  triggerIcon: PropTypes.string,
  triggerDisabled: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  onRef: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
};

Collapsible.defaultProps = {
  transitionTime: 275, // The number of milliseconds for the open/close transition to take.
  easing: 'ease-in-out', // The CSS easing method you wish to apply to the open/close transition. This string can be any valid value of CSS transition-timing-function. For reference view the MDN documentation.
  defaultOpen: false, // Set to true if you want the Collapsible to begin in the open state. You can also use this prop to manage the state from a parent component.
  triggerDisabled: false, // Disables the trigger handler if true. Note: this has no effect other than applying the _state_disabled CSS class if you've provided a handleTriggerClick prop.
  onOpen: Function.prototype, // Is called when the Collapsible is opening.
  onClose: Function.prototype, // Is called when the Collapsible is closed.
  handleTriggerClick: Function.prototype, // Define this to override the click handler for the trigger link. Takes one parameter, which is props.accordionPosition
  accordionPosition: '', // Unique key used to identify the Collapse instance when used in an accordion.
  triggerText: '', // Set Trigger text
  children: '',
  triggerIcon: 'arrow_left',
  onRef: Function.prototype,
};

export default Collapsible;
